import { Film, Loader2 } from "lucide-react";
import ClipCard from "./ClipCard";

export default function JobDetailsPanel({
  selectedJob,
  clips,
  clipsLoading,
  handleRetry,
  renderTimeline,
  getJobStateUI,
  setPreviewClip,
}) {
  if (!selectedJob) {
    return (
      <div className="flex flex-col items-center justify-center py-20 text-gray-400">
        <Film size={36} className="mb-3 opacity-70" />
        <p className="text-sm">Select a video to view details</p>
      </div>
    );
  }

  const state = getJobStateUI(selectedJob);

  if (state === "failed") {
    return (
      <div className="text-center py-20">
        <h2 className="font-semibold text-gray-800 mb-2">Processing Failed</h2>

        <div className="bg-red-50 border border-red-200 text-red-600 text-sm p-4 rounded-xl mb-6">
          {selectedJob.error || selectedJob.message}
        </div>

        <button className="bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700 transition">
          Retry
        </button>
      </div>
    );
  }

  if (state === "processing") {
    return (
      <div className="py-10 text-center">
        <Loader2 className="animate-spin mx-auto mb-4 text-indigo-600" />

        <div className="w-full max-w-md mx-auto bg-gray-100 rounded-full h-3 mb-4">
          <div
            className="bg-indigo-600 h-3 rounded-full transition-all duration-500"
            style={{ width: `${selectedJob.progress || 10}%` }}
          />
        </div>

        <p className="text-xs text-gray-500 mb-4">{selectedJob.message}</p>

        {renderTimeline()}
      </div>
    );
  }

  if (state === "completed") {
    return (
      <>
        <h2 className="text-sm font-semibold text-gray-800 mb-4">
          Generated Clips
        </h2>

        {clipsLoading ? (
          <Loader2 className="animate-spin" />
        ) : (
          <div className="grid md:grid-cols-2 gap-4">
            {clips.map((clip) => (
              <ClipCard key={clip.id} clip={clip} />
            ))}
          </div>
        )}
      </>
    );
  }
}
